/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Save Icon component.
 */
export const SaveIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_22986_20329)'>
        <path d='M17.1464 3.14645C17.0527 3.05268 16.9255 3 16.7929 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V7.20711C21 7.0745 20.9473 6.94732 20.8536 6.85355L17.1464 3.14645ZM12 12C10.34 12 9 13.34 9 15C9 16.66 10.34 18 12 18C13.66 18 15 16.66 15 15C15 13.34 13.66 12 12 12ZM6 6.5C6 6.22386 6.22386 6 6.5 6H14.5C14.7761 6 15 6.22386 15 6.5V9.5C15 9.77614 14.7761 10 14.5 10H6.5C6.22386 10 6 9.77614 6 9.5V6.5Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
        <circle cx='22.1998' cy='1.75007' r='1.67097' fill={dlsColor('caRed')} />
      </g>
      <defs>
        <clipPath id='clip0_22986_20329'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SaveIcon;
